import { defineMessages } from 'react-intl';

const messages = defineMessages({
  assetsListNoPreview: {
    id: 'assetsListNoPreview',
    defaultMessage: 'Preview not available',
    description: 'Label shown when no preview is available',
  },
  assetsListNameLabel: {
    id: 'assetsListNameLabel',
    defaultMessage: 'Name',
    description: 'Label for column header',
  },
  assetsListDateLabel: {
    id: 'assetsListDateLabel',
    defaultMessage: 'Date Added',
    description: 'Label for column header',
  },
});

export default messages;
